var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTooltipIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 5.48989C5.5 5.35728 5.55268 5.23011 5.64645 5.13634C5.74021 5.04257 5.86739 4.98989 6 4.98989C6.13261 4.98989 6.25979 5.04257 6.35355 5.13634C6.44732 5.23011 6.5 5.35728 6.5 5.48989V8.48989C6.5 8.6225 6.44732 8.74968 6.35355 8.84344C6.25979 8.93721 6.13261 8.98989 6 8.98989C5.86739 8.98989 5.74021 8.93721 5.64645 8.84344C5.55268 8.74968 5.5 8.6225 5.5 8.48989V5.48989ZM6 3.02539C5.86739 3.02539 5.74021 3.07807 5.64645 3.17184C5.55268 3.26561 5.5 3.39278 5.5 3.52539C5.5 3.658 5.55268 3.78518 5.64645 3.87894C5.74021 3.97271 5.86739 4.02539 6 4.02539C6.13261 4.02539 6.25979 3.97271 6.35355 3.87894C6.44732 3.78518 6.5 3.658 6.5 3.52539C6.5 3.39278 6.44732 3.26561 6.35355 3.17184C6.25979 3.07807 6.13261 3.02539 6 3.02539Z",
    fill: "#878CA4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 1C3.2385 1 1 3.2385 1 6C1 8.7615 3.2385 11 6 11C8.7615 11 11 8.7615 11 6C11 3.2385 8.7615 1 6 1ZM2 6C2 7.06087 2.42143 8.07828 3.17157 8.82843C3.92172 9.57857 4.93913 10 6 10C7.06087 10 8.07828 9.57857 8.82843 8.82843C9.57857 8.07828 10 7.06087 10 6C10 4.93913 9.57857 3.92172 8.82843 3.17157C8.07828 2.42143 7.06087 2 6 2C4.93913 2 3.92172 2.42143 3.17157 3.17157C2.42143 3.92172 2 4.93913 2 6Z",
    fill: "#878CA4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltipIcon);
export default __webpack_public_path__ + "static/media/tooltip-icon.4769821f6ba397cf3d73cd8aa10921bd.svg";
export { ForwardRef as ReactComponent };